import React, { useState, useEffect } from 'react'
import {
  Stack,
  Heading,
  Text,
  Badge,
  Loading,
  EmptyBox,
  SimpleGrid,
  Card,
  Alert
} from '@/components/lib'
import api from '../../../api'
import utils from '../../../utils/utils'
// import useStore from '../../../store'

export default function Incentives ({ trialId, participantId }) {
  const [incentives, setIncentives] = useState([])
  const [loading, setLoading] = useState(true)
  // const { team } = useStore()

  useEffect(() => {
    if (!trialId || !participantId) return
    setLoading(true)
    api.tillo.listIncentives(trialId, participantId, (d) => {
      setIncentives(d.incentives || [])
      setLoading(false)
    }, () => setLoading(false))
  }, [trialId, participantId])

  if (loading) return <Loading />

  return (
    <Stack gap={5}>
      <Stack direction='row' justifyContent='space-between' alignItems='center'>
        <Heading>Incentives</Heading>
      </Stack>

      {/*! utils.hasFeature(team, 'participantIncentives') && (
        <Alert>
          <Text>Participant incentives are not available for your account. Please contact your administrator to enable this feature.</Text>
        </Alert>
      ) */}

      <Alert title='Early access' status='info'>This feature is in early access and is not yet generally available.</Alert>

      {incentives.length === 0 && (
        <EmptyBox icon='giftcard' title='No incentives issued yet'>
          <Text>Gift cards issued to this participant will appear here.</Text>
        </EmptyBox>
      )}

      {incentives.length > 0 && (
        <SimpleGrid columns={{ base: 1, md: 2 }} gap={4}>
          {incentives.map((incentive) => (
            <Card key={incentive._id}>
              <Stack gap={3}>
                <Stack direction='row' justifyContent='space-between' alignItems='flex-start'>
                  <Heading size='sm'>{incentive.brandName || incentive.brand}</Heading>
                  <Badge colorPalette='green' variant='subtle' size='sm'>
                    {incentive.status}
                  </Badge>
                </Stack>

                <Stack direction='row' gap={4}>
                  {incentive.faceValue && (
                    <Stack gap={0}>
                      <Text fontSize='xs' color='fg.subtle'>Value</Text>
                      <Text fontWeight='bold'>
                        {incentive.faceValue.currency} {incentive.faceValue.amount?.toFixed(2)}
                      </Text>
                    </Stack>
                  )}
                  {incentive.costValue && (
                    <Stack gap={0}>
                      <Text fontSize='xs' color='fg.subtle'>Cost</Text>
                      <Text fontSize='sm'>
                        {incentive.costValue.currency} {incentive.costValue.amount?.toFixed(2)}
                      </Text>
                    </Stack>
                  )}
                </Stack>

                <Stack gap={1}>
                  <Text fontSize='xs' color='fg.subtle'>Issued</Text>
                  <Text fontSize='sm'>{utils.formatDateTime(incentive.createdAt)}</Text>
                </Stack>

                {incentive.expirationDate && (
                  <Stack gap={1}>
                    <Text fontSize='xs' color='fg.subtle'>Expires</Text>
                    <Text fontSize='sm'>{utils.formatDateTime(incentive.expirationDate)}</Text>
                  </Stack>
                )}

                {incentive.tilloReference && (
                  <Stack gap={1}>
                    <Text fontSize='xs' color='fg.subtle'>Reference</Text>
                    <Text fontSize='xs' fontFamily='monospace'>{incentive.tilloReference}</Text>
                  </Stack>
                )}
              </Stack>
            </Card>
          ))}
        </SimpleGrid>
      )}
    </Stack>
  )
}
